function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.35 12C20.35 16.6116 16.6116 20.35 12 20.35C7.38842 20.35 3.65 16.6116 3.65 12C3.65 7.38842 7.38842 3.65 12 3.65C16.6116 3.65 20.35 7.38842 20.35 12Z",
  stroke: "#D61F26",
  strokeWidth: 1.3
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.17163 14.8284L14.8285 9.17151",
  stroke: "#D61F26",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.17163 9.17163L14.8285 14.8285",
  stroke: "#D61F26",
  strokeWidth: 2,
  strokeLinecap: "round"
});
const SvgError = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.1e201a5d.svg";
export { ForwardRef as ReactComponent };